import classNames from 'classnames'

export const SECTION_TITLE_DEFAULT_CLASSES = 'jost text-[0.9em] sm:text-[1.1em] text-text'

interface ItemProps {
  text: any
  classes?: string
}

export const SectionTitle = ({ text, classes }: ItemProps) => (
  <div className={classNames(SECTION_TITLE_DEFAULT_CLASSES, classes)}>{text}</div>
)
